module.exports = __webpack_public_path__ + "img/preview-banner.c9174398.png";